module.exports = __webpack_public_path__ + "static/media/IMG_7023 edit.93bd3566.png";